import React from 'react'
import AppBar from './AppBar'

export default function PageComponent({ children }) {
  return (
    <div className='overflow-x-hidden'>
      <div className='ml-64'>
      <AppBar/>
      </div>
     
      {children}
    </div>
  )
}
